/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_DeleteInputs */

const en_admin_questionnaire_editor_delete = /** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const de_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const es_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const it_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/** @type {(inputs: Admin_Questionnaire_Editor_DeleteInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_delete = en_admin_questionnaire_editor_delete;

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Admin_Questionnaire_Editor_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_delete = /** @type {((inputs?: Admin_Questionnaire_Editor_DeleteInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_DeleteInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_delete(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_delete(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_delete(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_delete(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_delete(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_delete(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_delete(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_delete(inputs)
	return ro_admin_questionnaire_editor_delete(inputs)
});
export { admin_questionnaire_editor_delete as "admin.questionnaire_editor.delete" }